import { Link } from "@custom/schema";
import clsx from "clsx";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDomain } from "../../utils/domain";
import { getLocalizedUrl } from "../../utils/url";
export var Logo = function Logo(param) {
  var domainId = param.domainId,
    _param_isDesktop = param.isDesktop,
    isDesktop = _param_isDesktop === void 0 ? false : _param_isDesktop,
    _param_noPadding = param.noPadding,
    noPadding = _param_noPadding === void 0 ? false : _param_noPadding,
    _param_isWhiteLogo = param.isWhiteLogo,
    isWhiteLogo = _param_isWhiteLogo === void 0 ? false : _param_isWhiteLogo;
  var _domain_logoNoPaddingSvg, _domain_logosvg;
  var domain = useDomain(domainId);
  var t = useTranslation().t;
  var _useTranslation = useTranslation(),
    _useTranslation_i18n = _useTranslation.i18n,
    locale = _useTranslation_i18n.language;
  var logoSvg = noPadding ? domain === null || domain === void 0 ? void 0 : (_domain_logoNoPaddingSvg = domain.logoNoPaddingSvg) === null || _domain_logoNoPaddingSvg === void 0 ? void 0 : _domain_logoNoPaddingSvg[locale] : domain === null || domain === void 0 ? void 0 : (_domain_logosvg = domain.logosvg) === null || _domain_logosvg === void 0 ? void 0 : _domain_logosvg[locale];
  var logoWhite = isWhiteLogo ? domain === null || domain === void 0 ? void 0 : domain.groupSVGWhite : "";
  var homeLink = getLocalizedUrl({
    to: "/",
    locale: locale,
    domain: domain
  }).url;
  return /*#__PURE__*/React.createElement("div", {
    className: clsx("SiteLogo-wrapper", {
      SiteLogo: isDesktop,
      "is-hidden-desktop": !isDesktop
    })
  }, /*#__PURE__*/React.createElement(Link, {
    href: homeLink,
    className: clsx("SiteLogo--link", {
      "is-hidden-tablet-portrait": isDesktop,
      "is-visible-tablet-portrait": !isDesktop
    }),
    id: "SiteLogo--link",
    title: t(domain.title)
  }, /*#__PURE__*/React.createElement("img", {
    alt: t(domain.title),
    className: clsx(["SiteLogo--img", domain === null || domain === void 0 ? void 0 : domain.id]),
    src: isWhiteLogo ? logoWhite : logoSvg
  })));
};